// 等待页面加载完成
document.addEventListener('DOMContentLoaded', function() {
  // 选择所有带 lazyload 类的图片
  const lazyImages = document.querySelectorAll('img.lazyload');

  // 检查浏览器是否支持 IntersectionObserver
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {  // 图片进入视口
          const image = entry.target;
          // 将 data-src 赋值给 src（加载真实图片）
          image.src = image.dataset.src;
          // 若有 data-srcset，同步赋值
          if (image.dataset.srcset) {
            image.srcset = image.dataset.srcset;
          }
          image.classList.remove('lazyload');  // 移除类名（避免重复加载）
          imageObserver.unobserve(image);  // 停止监听该图片
        }
      });
    });

    // 监听所有懒加载图片
    lazyImages.forEach(image => {
      imageObserver.observe(image);
    });
  } else {
    // 兼容不支持 IntersectionObserver 的旧浏览器（可选）
    lazyImages.forEach(image => {
      image.src = image.dataset.src;
      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
      }
      image.classList.remove('lazyload');
    });
  }
});